import React from "react";
import { useTranslation } from "react-i18next";
import Visibility from "../utils/Visibility";
import BranchInfo from "./BranchInfo";
import SocialMedia from "./SocialMedia";
import BranchModel from "../../Models/BranchModel";
import SocialMeidaModel from "../../Models/SocialMeidaModel";
import { SheetContent, SheetHeader, SheetTitle } from "../ui/sheet";
import { indexStore } from "../../store/indexStore";
const Details = (props: {
  branch: BranchModel;
  social: SocialMeidaModel[];
}) => {
  const { t } = useTranslation();

  const { social, branch } = indexStore();
  return (
    <SheetContent
      side={"bottom"}
      // style={{ background: s }}
      className="flex flex-col p-4 max-h-[60vh] overflow-y-auto z-50 "
    >
      <SheetHeader>
        <SheetTitle>
          <h2 className="text-xl font-bold mb-4">{t("gloabl.info")}</h2>
        </SheetTitle>
      </SheetHeader>
      <div className="flex flex-col">
        <BranchInfo branch={branch} />
        <Visibility visible={social && social.length !== 0}>
          <SocialMedia social={social} />
        </Visibility>
      </div>
    </SheetContent>
  );
};
export default Details;
